/**
 * @packageDocumentation
 * @module api.functional.companies
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CompanySummaryDto } from "../../structures/CompanySummaryDto";
import type { GetCompanyDetailDto } from "../../structures/GetCompanyDetailDto";

export * as subsidiary from "./subsidiary/index";
export * as invitations from "./invitations/index";
export * as members from "./members/index";

/**
 * @controller CompanyExternalController.listCompanies
 * @path GET /companies
 * @accessor api.functional.companies.listCompanies
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function listCompanies(
  connection: IConnection,
): Promise<listCompanies.Output> {
  return PlainFetcher.fetch(connection, {
    ...listCompanies.METADATA,
    template: listCompanies.METADATA.path,
    path: listCompanies.path(),
  });
}
export namespace listCompanies {
  export type Output = CompanySummaryDto[];

  export const METADATA = {
    method: "GET",
    path: "/companies",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/companies";
}

/**
 * @controller CompanyExternalController.getCompanyByQBOId
 * @path GET /companies/:QBOId
 * @accessor api.functional.companies.getCompanyByQBOId
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getCompanyByQBOId(
  connection: IConnection,
  QBOId: number,
): Promise<getCompanyByQBOId.Output> {
  return PlainFetcher.fetch(connection, {
    ...getCompanyByQBOId.METADATA,
    template: getCompanyByQBOId.METADATA.path,
    path: getCompanyByQBOId.path(QBOId),
  });
}
export namespace getCompanyByQBOId {
  export type Output = GetCompanyDetailDto;

  export const METADATA = {
    method: "GET",
    path: "/companies/:QBOId",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (QBOId: number) =>
    `/companies/${encodeURIComponent(QBOId?.toString() ?? "null")}`;
}
